import React, { useEffect, useState } from "react";
import "./Field_Mapping.css";
import { BackendURL } from "../../../env";
import {
  Modal,
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

function Field_Mapping() {
  const [open, setOpen] = useState(false);
  const [historyOpen, setHistoryOpen] = useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const handleClose = () => setOpen(false);
  const handleOpen = () => setOpen(true);
  const [sourceConnectionState, setSourceConnectionState] = useState("idle");
  const [destConnectionState, setDestConnectionState] = useState("idle");
  const [sourceDatabases, setSourceDatabases] = useState([]);
  const [destDatabases, setDestDatabases] = useState([]);
  const [selectedSourceDB, setSelectedSourceDB] = useState("");
  const [selectedDestDB, setSelectedDestDB] = useState("");
  const [runState, setRunState] = useState("idle");
  const [historyData, setHistoryData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [sourceDBType, setSourceDBType] = useState("SQL");
  const [destinationDBType, setDestinationDBType] = useState("SQL");
  const [sourceAzureAccountName, setSourceAzureAccountName] = useState("");
  const [sourceAzureAccountId, setSourceAzureAccountId] = useState("");
  const [FileUrl, setFileUrl] = useState("");

  const [destAzureAccountName, setDestAzureAccountName] = useState("");
  const [destAzureAccountId, setDestAzureAccountId] = useState("");
  const [sourceBlobContainers, setSourceBlobContainers] = useState<string[]>(
    []
  );
  const [destBlobContainers, setDestBlobContainers] = useState<string[]>([]);

  const [selectedSourceContainer, setSelectedSourceContainer] =
    useState<string>("");
  const [selectedDestContainer, setSelectedDestContainer] =
    useState<string>("");

  const connectionLocked =
    sourceConnectionState === "connected" ||
    destConnectionState === "connected";

  const handleSourceChange = (type: string) => {
    if (connectionLocked) return;
    setSourceDBType(type);
    setDestinationDBType(type);
  };

  const handleDestinationChange = (type: string) => {
    if (connectionLocked) return;
    setDestinationDBType(type);
    setSourceDBType(type);
  };

  const [sourceData, setSourceData] = useState({
    conn_type: "sql",
    server: "",
    database: "",
    username: "",
    password: "",
  });

  const [destData, setDestData] = useState({
    conn_type: "sql",
    server: "",
    database: "",
    username: "",
    password: "",
  });

  useEffect(() => {
    if (historyOpen) {
      fetchHistoryData();
    }
  }, [historyOpen]);

  const fetchHistoryData = async () => {
    const Email = localStorage.getItem("Email");
    try {
      setLoading(true);
      const response = await fetch(`${BackendURL}/Feature/FieldMapping/Get_uploaded_files`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ Email }),
      });
      const result = await response.json();

      setFileUrl(result.url);

      if (result && Array.isArray(result.files)) {
        setHistoryData(result.files);
      } else {
        setHistoryData([]);
      }
    } catch (error) {
      console.error("Error fetching history:", error);
      setHistoryData([]);
    } finally {
      setLoading(false);
    }
  };

const handleDownload = (fileUrl: string, filename: string) => {
  const link = document.createElement("a");
  link.href = fileUrl;      
  link.download = filename;  
  document.body.appendChild(link);
  link.click();
  link.remove();
};


  const downloadExcel = (data: any) => {
    if (!data || !Array.isArray(data)) {
      alert("No data to download!");
      return;
    }

    const formattedData = data.map((item: any) => {
      if (typeof item === "object") return item;
      return {};
    });

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "RunResult");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });

    const dateObj = new Date();
    const date = `${String(dateObj.getDate()).padStart(2, "0")}-${String(
      dateObj.getMonth() + 1
    ).padStart(2, "0")}-${dateObj.getFullYear()}`;

    let hours = dateObj.getHours();
    const minutes = String(dateObj.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    const time = `${String(hours).padStart(2, "0")}_${minutes}${ampm}`;

    saveAs(blob, `FM${date}_${time}.xlsx`);
  };

  const handleInputChange = (
    e: { target: { name: any; value: any } },
    type: string
  ) => {
    const { name, value } = e.target;
    if (type === "source") {
      setSourceData((prev) => ({ ...prev, [name]: value }));
    } else {
      setDestData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const connectAPI = async (data: any, type: string, connType: string) => {
    const setState =
      type === "source" ? setSourceConnectionState : setDestConnectionState;
    const setDatabases =
      type === "source" ? setSourceDatabases : setDestDatabases;

    try {
      setState("connecting");

      const payload =
        connType === "AzureBlob"
          ? {
            conn_type: "azure",
            server: "",
            database: "",
            username: "",
            password: "",
            azure_account_name:
              type === "source"
                ? sourceAzureAccountName
                : destAzureAccountName,
            azure_container_name:
              type === "source"
                ? selectedSourceContainer
                : selectedDestContainer,
            azure_account_id:
              type === "source" ? sourceAzureAccountId : destAzureAccountId,
          }
          : {
            conn_type: "sql",
            server: data.server || "",
            database: data.database || "",
            username: data.username || "",
            password: data.password || "",
            azure_account_name: "",
            azure_container_name: "",
            azure_account_id: "",
          };

      const response = await fetch(
        "/Feature/FieldMapping/EstablishConnection",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) throw new Error("Connection failed");

      const result = await response.json();

      if (connType === "AzureBlob") {
        if (type === "source") setSourceBlobContainers(result.containers || []);
        else setDestBlobContainers(result.containers || []);
      } else {
        setDatabases(result.databases || []);
      }

      setState("connected");
    } catch (error) {
      console.error(`${type} connection error:`, error);
      setState("idle");
      setErrorMessage(`${type.toUpperCase()} Connection Failed`);
      setErrorModalOpen(true);
    }
  };

  const handleRun = async () => {
    if (
      sourceConnectionState !== "connected" ||
      destConnectionState !== "connected"
    ) {
      setErrorMessage(
        "Both source and destination must be connected before running!"
      );
      setErrorModalOpen(true);
      return;
    }

    setRunState("running");

    const connType = sourceDBType;
    const Email = localStorage.getItem("Email");

    const body =
      connType === "AzureBlob"
        ? {
          conn_type: "azure",
          Email: Email,
          azure_account_name: sourceAzureAccountName || "",
          azure_account_id: sourceAzureAccountId || "",
          //   azure_account_name_target: destAzureAccountName || "",
          //   azure_account_id_target: destAzureAccountId || "",
          blob_name_source: selectedSourceContainer || "",
          blob_name_target: selectedDestContainer || "",
          server_source: "",
          database_source: "",
          username_source: "",
          password_source: "",
          server_target: "",
          database_target: "",
          username_target: "",
          password_target: "",
        }
        : {
          conn_type: "sql",
          Email: Email,
          server_source: sourceData.server || "",
          database_source: selectedSourceDB || "",
          username_source: sourceData.username || "",
          password_source: sourceData.password || "",
          server_target: destData.server || "",
          database_target: selectedDestDB || "",
          username_target: destData.username || "",
          password_target: destData.password || "",
          azure_account_name: "",
          azure_account_id: "",
          blob_name_source: "",
          blob_name_target: "",
        };

    try {
      const response = await fetch("/Feature/FieldMapping/ExecuteMapping", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });

      if (!response.ok) throw new Error("Run failed");

      const result = await response.json();

      if (result.blob_url) {
        const link = document.createElement("a");
        link.href = result.blob_url;
        link.download = "Mapping_Result.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        downloadExcel(result);
      }

      setRunState("success");
      handleOpen();
    } catch (error) {
      console.error("Run error:", error);
      setRunState("idle");
      setErrorMessage("Run failed. Check console for details.");
      setErrorModalOpen(true);
    }
  };

  const handleReset = () => {
    setSourceData({
      conn_type: "sql",
      server: "",
      database: "",
      username: "",
      password: "",
    });

    setDestData({
      conn_type: "sql",
      server: "",
      database: "",
      username: "",
      password: "",
    });

    // Reset Azure fields
    setSourceAzureAccountName("");
    setSourceAzureAccountId("");
    setDestAzureAccountName("");
    setDestAzureAccountId("");

    // Reset blob containers
    setSourceBlobContainers([]);
    setDestBlobContainers([]);

    // Reset selected container names
    setSelectedSourceContainer("");
    setSelectedDestContainer("");

    setSelectedSourceDB("");
    setSelectedDestDB("");

    setSourceConnectionState("idle");
    setDestConnectionState("idle");

    setSourceDBType("SQL");
    setDestinationDBType("SQL");

    setRunState("idle");
  };

  const renderConnectButton = (
    state: any,
    onClick: React.MouseEventHandler<HTMLButtonElement> | undefined
  ) => {
    switch (state) {
      case "connecting":
        return (
          <button
            type="button"
            className="btn btn-primary connect-btn"
            disabled
          >
            Connecting{" "}
            <i className="spinner-border text-success customize-spinner"></i>
          </button>
        );
      case "connected":
        return (
          <button
            type="button"
            className="btn btn-primary connect-btn"
            disabled
          >
            Connected{" "}
            <i>
              <svg
                stroke="currentColor"
                fill="currentColor"
                strokeWidth="0"
                viewBox="0 0 512 512"
                height="20"
                width="20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M362.6 192.9L345 174.8c-.7-.8-1.8-1.2-2.8-1.2-1.1 0-2.1.4-2.8 1.2l-122 122.9-44.4-44.4c-.8-.8-1.8-1.2-2.8-1.2-1 0-2 .4-2.8 1.2l-17.8 17.8c-1.6 1.6-1.6 4.1 0 5.7l56 56c3.6 3.6 8 5.7 11.7 5.7 5.3 0 9.9-3.9 11.6-5.5h.1l133.7-134.4c1.4-1.7 1.4-4.2-.1-5.7z"></path>
                <path d="M256 76c48.1 0 93.3 18.7 127.3 52.7S436 207.9 436 256s-18.7 93.3-52.7 127.3S304.1 436 256 436c-48.1 0-93.3-18.7-127.3-52.7S76 304.1 76 256s18.7-93.3 52.7-127.3S207.9 76 256 76m0-28C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48z"></path>
              </svg>
            </i>
          </button>
        );
      default:
        return (
          <button
            type="button"
            className="btn btn-primary connect-btn"
            onClick={onClick}
          >
            Connect
          </button>
        );
    }
  };

  useEffect(() => {
    if (sourceDatabases.length > 0) {
      setSelectedSourceDB(sourceDatabases[0]);
      setSelectedDestDB(destDatabases[0]);
    } else {
      setSelectedSourceDB("");
      setSelectedDestDB("");
    }

    if (open) {
      const timer = setTimeout(() => {
        handleClose();
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [sourceDatabases, open]);

  const historyHandleOpen = () => setHistoryOpen(true);
  const historyHandleClose = () => setHistoryOpen(false);
  const historyhandleCancel = () => setHistoryOpen(false);

  return (
    <div className="fieldMappingMain-wrapper">
      <nav
        className="navbar navbar-expand-sm bg-dark navbar-dark navbar-header"
      // style={{ backgroundColor: "#db2128!important", height: "48px" }}
      >
        <div className="container-fluid">
          <a
            href="#"
            className="brand"
            style={{
              color: "#fff",
              textDecoration: "none",
              fontWeight: 600,
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <svg
              stroke="currentColor"
              fill="currentColor"
              strokeWidth="0"
              viewBox="0 0 20 20"
              aria-hidden="true"
              height="1em"
              width="1em"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M3 12v3c0 1.657 3.134 3 7 3s7-1.343 7-3v-3c0 1.657-3.134 3-7 3s-7-1.343-7-3z"></path>
              <path d="M3 7v3c0 1.657 3.134 3 7 3s7-1.343 7-3V7c0 1.657-3.134 3-7 3S3 8.657 3 7z"></path>
              <path d="M17 5c0 1.657-3.134 3-7 3S3 6.657 3 5s3.134-3 7-3 7 1.343 7 3z"></path>
            </svg>
            Source to Target Field Mapping
          </a>

        </div>
      </nav>



      <div className="container-fluid pt-2 pb-1 container-fluid-bg">
        <div className="container mb-3">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-6 mt-1">
              <div className="soruce-wrapper equal-height">
                <h2 className="source-wrapper-title">Source</h2>
                <div className="form-row-wrapper-databasetype">
                  <label htmlFor="">Database Type</label>
                  <div className="db-check-wrapper">
                    <div className="form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        id="radioSourceSQL"
                        name="sourceType"
                        value="SQL"
                        checked={sourceDBType === "SQL"}
                        onChange={() => handleSourceChange("SQL")}
                        disabled={connectionLocked}
                      />
                      SQL
                      <label
                        className="form-check-label"
                        htmlFor="radioSourceSQL"
                      ></label>
                    </div>
                    <div className="form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        id="radioSourceAzure"
                        name="sourceType"
                        value="AzureBlob"
                        checked={sourceDBType === "AzureBlob"}
                        onChange={() => handleSourceChange("AzureBlob")}
                        disabled={connectionLocked}
                      />
                      Azure Blob
                      <label
                        className="form-check-label"
                        htmlFor="radioSourceAzure"
                      ></label>
                    </div>
                  </div>
                </div>

                <div className="tabwrapper">
                  <div className="tabwrapper-btns d-flex align-items justify-content-center">
                    <ul className="nav nav-pills" role="tablist">
                      <li className="nav-item">
                        <a
                          className="nav-link active"
                          data-bs-toggle="pill"
                          href="#server"
                        >
                          Server
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link"
                          data-bs-toggle="pill"
                          href="#connection"
                        >
                          Connection
                        </a>
                      </li>
                    </ul>
                  </div>

                  <div className="tab-content">
                    <div id="server" className="tab-pane active">
                      <br />
                      {sourceDBType === "SQL" && (
                        <>
                          <div className="form-row-wrapper">
                            <label>Server Name/IP</label>
                            <input
                              type="text"
                              name="server"
                              className="form-control"
                              placeholder="Enter Server Name/IP"
                              value={sourceData.server}
                              onChange={(e) => handleInputChange(e, "source")}
                            />
                          </div>
                          <div className="form-row-wrapper">
                            <label>User Name</label>
                            <input
                              type="text"
                              name="username"
                              className="form-control"
                              placeholder="Enter User Name"
                              value={sourceData.username}
                              onChange={(e) => handleInputChange(e, "source")}
                            />
                          </div>
                          <div className="form-row-wrapper">
                            <label>Password</label>
                            <input
                              type="password"
                              name="password"
                              className="form-control"
                              placeholder="Enter Password"
                              value={sourceData.password}
                              onChange={(e) => handleInputChange(e, "source")}
                            />
                          </div>
                        </>
                      )}
                      {/*Azure Account Fields  */}
                      {sourceDBType === "AzureBlob" && (
                        <>
                          <div className="form-row-wrapper">
                            <label
                              htmlFor="azureAccountName"
                              className="form-label"
                            >
                              Azure Account Name
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="azureAccountName"
                              placeholder="Enter Azure Account Name"
                              name="azureAccountName"
                              value={sourceAzureAccountName}
                              onChange={(e) =>
                                setSourceAzureAccountName(e.target.value)
                              }
                            />
                          </div>
                          <div className="form-row-wrapper">
                            <label
                              htmlFor="azureAccountId"
                              className="form-label"
                            >
                              Azure Account Key
                            </label>
                            <input
                              type="password"
                              className="form-control"
                              id="azureAccountId"
                              placeholder="Enter Azure Account Key"
                              name="azureAccountId"
                              value={sourceAzureAccountId}
                              onChange={(e) =>
                                setSourceAzureAccountId(e.target.value)
                              }
                            />
                          </div>
                        </>
                      )}
                    </div>

                    <div id="connection" className="tab-pane ">
                      <br />
                      <div className="form-row-wrapper">
                        <label htmlFor="connection" className="form-label">
                          Connection
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="password"
                          placeholder="Enter Connection"
                          name="connection"
                        />
                      </div>
                    </div>
                    <div className="form-row-wrapper justify-content-end">
                      {renderConnectButton(sourceConnectionState, () =>
                        connectAPI(sourceData, "source", sourceDBType)
                      )}
                    </div>
                    {sourceDBType === "SQL" && (
                      <div className="form-row-wrapper mb-0">
                        <label>Database</label>
                        <select
                          className="form-select"
                          disabled={sourceConnectionState !== "connected"}
                          style={{
                            opacity:
                              sourceConnectionState === "connected" ? 1 : 0.5,
                          }}
                          onChange={(e) => setSelectedSourceDB(e.target.value)}
                        >
                          {sourceDatabases.length > 0 ? (
                            sourceDatabases.map((db, idx) => (
                              <option key={idx} value={db}>
                                {db}
                              </option>
                            ))
                          ) : (
                            <option>-- Select Database --</option>
                          )}
                        </select>
                      </div>
                    )}

                    {sourceDBType === "AzureBlob" && (
                      <div className="form-row-wrapper">
                        <label
                          htmlFor="sourceBlobContainer"
                          className="form-label"
                        >
                          Blob Container
                        </label>
                        <select
                          className="form-select"
                          id="sourceBlobContainer"
                          name="sourceBlobContainer"
                          value={selectedSourceContainer}
                          onChange={(e) =>
                            setSelectedSourceContainer(e.target.value)
                          }
                          disabled={sourceConnectionState !== "connected"}
                          style={{
                            opacity:
                              sourceConnectionState === "connected" ? 1 : 0.5,
                          }}
                        >
                          {sourceBlobContainers.length > 0 ? (
                            sourceBlobContainers.map((container) => (
                              <option key={container} value={container}>
                                {container}
                              </option>
                            ))
                          ) : (
                            <option>-- Select Container --</option>
                          )}
                        </select>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-12 col-md-12 col-lg-6 mt-1">
              <div className="soruce-wrapper equal-height">
                <h2 className="source-wrapper-title">Destination</h2>
                <div className="form-row-wrapper-databasetype">
                  <label htmlFor="">Database Type</label>
                  <div className="db-check-wrapper">
                    <div className="form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        id="radioDestSQL"
                        name="destType"
                        value="SQL"
                        checked={destinationDBType === "SQL"}
                        onChange={() => handleDestinationChange("SQL")}
                        disabled={connectionLocked}
                      />
                      SQL
                      <label
                        className="form-check-label"
                        htmlFor="radioDestSQL"
                      ></label>
                    </div>
                    <div className="form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        id="radioDestAzure"
                        name="destType"
                        value="AzureBlob"
                        checked={destinationDBType === "AzureBlob"}
                        onChange={() => handleDestinationChange("AzureBlob")}
                        disabled={connectionLocked}
                      />
                      Azure Blob
                      <label
                        className="form-check-label"
                        htmlFor="radioDestAzure"
                      ></label>
                    </div>
                  </div>
                </div>

                <div className="tabwrapper">
                  <div className="tabwrapper-btns d-flex align-items justify-content-center">
                    <ul className="nav nav-pills" role="tablist">
                      <li className="nav-item">
                        <a
                          className="nav-link active"
                          data-bs-toggle="pill"
                          href="#destinationserver"
                        >
                          Server
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link"
                          data-bs-toggle="pill"
                          href="#destinationconnection"
                        >
                          Connection
                        </a>
                      </li>
                    </ul>
                  </div>

                  <div className="tab-content">
                    <div id="destinationserver" className="tab-pane active">
                      <br />
                      {sourceDBType === "SQL" && (
                        <>
                          <div className="form-row-wrapper">
                            <label>Server Name/IP</label>
                            <input
                              type="text"
                              name="server"
                              className="form-control"
                              placeholder="Enter Server Name/IP"
                              value={destData.server}
                              onChange={(e) => handleInputChange(e, "dest")}
                            />
                          </div>
                          <div className="form-row-wrapper">
                            <label>User Name</label>
                            <input
                              type="text"
                              name="username"
                              className="form-control"
                              placeholder="Enter User Name"
                              value={destData.username}
                              onChange={(e) => handleInputChange(e, "dest")}
                            />
                          </div>

                          <div className="form-row-wrapper">
                            <label>Password</label>
                            <input
                              type="password"
                              name="password"
                              className="form-control"
                              placeholder="Enter Password"
                              value={destData.password}
                              onChange={(e) => handleInputChange(e, "dest")}
                            />
                          </div>
                        </>
                      )}

                      {destinationDBType === "AzureBlob" && (
                        <>
                          <div className="form-row-wrapper">
                            <label
                              htmlFor="azureAccountName"
                              className="form-label"
                            >
                              Azure Account Name
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="azureAccountName"
                              placeholder="Enter Azure Account Name"
                              name="azureAccountName"
                              value={destAzureAccountName}
                              onChange={(e) =>
                                setDestAzureAccountName(e.target.value)
                              }
                            />
                          </div>
                          <div className="form-row-wrapper">
                            <label
                              htmlFor="azureAccountId"
                              className="form-label"
                            >
                              Azure Account Key
                            </label>
                            <input
                              type="password"
                              className="form-control"
                              id="azureAccountId"
                              placeholder="Enter Azure Account Key"
                              name="azureAccountId"
                              value={destAzureAccountId}
                              onChange={(e) =>
                                setDestAzureAccountId(e.target.value)
                              }
                            />
                          </div>
                        </>
                      )}
                    </div>

                    <div id="destinationconnection" className="tab-pane">
                      <br />
                      <div className="form-row-wrapper">
                        <label htmlFor="connection" className="form-label">
                          Connection
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="password"
                          placeholder="Enter Connection"
                          name="connection"
                        />
                      </div>
                    </div>
                    <div className="form-row-wrapper justify-content-end">
                      {renderConnectButton(destConnectionState, () =>
                        connectAPI(destData, "dest", sourceDBType)
                      )}
                    </div>
                    {sourceDBType === "SQL" && (
                      <div className="form-row-wrapper mb-0">
                        <label>Database</label>
                        <select
                          className="form-select"
                          disabled={destConnectionState !== "connected"}
                          style={{
                            opacity:
                              destConnectionState === "connected" ? 1 : 0.5,
                          }}
                          onChange={(e) => setSelectedDestDB(e.target.value)}
                        >
                          {destDatabases.length > 0 ? (
                            destDatabases.map((db, idx) => (
                              <option key={idx} value={db}>
                                {db}
                              </option>
                            ))
                          ) : (
                            <option>-- Select Database --</option>
                          )}
                        </select>
                      </div>
                    )}
                    {destinationDBType === "AzureBlob" && (
                      <div className="form-row-wrapper">
                        <label
                          htmlFor="destinationBlobContainer"
                          className="form-label"
                        >
                          Blob Container
                        </label>
                        <select
                          className="form-select"
                          id="destinationBlobContainer"
                          name="destinationBlobContainer"
                          value={selectedDestContainer}
                          onChange={(e) =>
                            setSelectedDestContainer(e.target.value)
                          }
                          disabled={destConnectionState !== "connected"}
                          style={{
                            opacity:
                              destConnectionState === "connected" ? 1 : 0.5,
                          }}
                        >
                          {destBlobContainers.length > 0 ? (
                            destBlobContainers.map((container, idx) => (
                              <option key={idx} value={container}>
                                {container}
                              </option>
                            ))
                          ) : (
                            <option>-- Select Container --</option>
                          )}
                        </select>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container mb-2">
          <div className="soruce-wrapper ">
            <div className="row">
              <div className="col-sm-6">
                <div className="d-flex align-items-center justify-content-start ">
                  <button
                    className="btn run-btn"
                    onClick={handleRun}
                    disabled={
                      sourceConnectionState !== "connected" ||
                      destConnectionState !== "connected"
                    }
                  >
                    {runState === "running" ? (
                      <>
                        Running{" "}
                        <i className="spinner-border text-success customize-spinner"></i>
                      </>
                    ) : (
                      <>
                        Run{" "}
                        <i>
                          <svg
                            stroke="currentColor"
                            fill="currentColor"
                            strokeWidth="0"
                            viewBox="0 0 20 20"
                            height="100%"
                            width="100%"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M6.3 2.84A1.5 1.5 0 0 0 4 4.11v11.78a1.5 1.5 0 0 0 2.3 1.27l9.344-5.891a1.5 1.5 0 0 0 0-2.538L6.3 2.841Z"></path>
                          </svg>
                        </i>
                      </>
                    )}
                  </button>
                  <button className="btn reset-btn ms-2" onClick={handleReset}>
                    Reset
                  </button>
                </div>
              </div>
              {/* <div className="col-sm-4">
              <div className="successful-message">
                <span className="badge bg-success">Run Successfully</span>{" "}
              </div>
            </div>
            */}
              <div className="col-sm-6">
                <div className="d-flex align-items-center justify-content-end">
                  {/* <button className="btn btn-success downloadreport disabled">
                  <i>
                    <svg
                      stroke="currentColor"
                      fill="none"
                      stroke-width="2"
                      viewBox="0 0 24 24"
                      aria-hidden="true"
                      height="100%"
                      width="100%"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                      ></path>
                    </svg>
                  </i>
                  Download Report
                </button> */}
                  <button
                    className="btn viewreport"
                    onClick={historyHandleOpen}
                  >
                    <i>
                      <svg
                        stroke="currentColor"
                        fill="currentColor"
                        stroke-width="0"
                        viewBox="0 0 24 24"
                        height="100%"
                        width="100%"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path fill="none" d="M0 0h24v24H0V0z"></path>
                        <path d="M12 6.5a9.77 9.77 0 0 1 8.82 5.5c-1.65 3.37-5.02 5.5-8.82 5.5S4.83 15.37 3.18 12A9.77 9.77 0 0 1 12 6.5m0-2C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zm0 5a2.5 2.5 0 0 1 0 5 2.5 2.5 0 0 1 0-5m0-2c-2.48 0-4.5 2.02-4.5 4.5s2.02 4.5 4.5 4.5 4.5-2.02 4.5-4.5-2.02-4.5-4.5-4.5z"></path>
                      </svg>
                    </i>
                    View History
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mapping-footer">
        <p>Copyright @2025 by Lipi. All Rights Reserved. </p>
      </div>

      <Modal
        open={historyOpen}
        onClose={() => setHistoryOpen(false)}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            bgcolor: "#303030",
            p: 2,
            borderRadius: 2,
            boxShadow: 24,
            width: 600,
          }}
        >
          <Typography variant="h6" component="h2" gutterBottom>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <span className="process-history">Process History</span>
              <button className="btn btn-close-history" onClick={() => setHistoryOpen(false)} > <i> <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 1024 1024" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg" > <path d="M799.855 166.312c.023.007.043.018.084.059l57.69 57.69c.041.041.052.06.059.084a.118.118 0 0 1 0 .069c-.007.023-.018.042-.059.083L569.926 512l287.703 287.703c.041.04.052.06.059.083a.118.118 0 0 1 0 .07c-.007.022-.018.042-.059.083l-57.69 57.69c-.041.041-.06.052-.084.059a.118.118 0 0 1-.069 0c-.023-.007-.042-.018-.083-.059L512 569.926 224.297 857.629c-.04.041-.06.052-.083.059a.118.118 0 0 1-.07 0c-.022-.007-.042-.018-.083-.059l-57.69-57.69c-.041-.041-.052-.06-.059-.084a.118.118 0 0 1 0-.069c.007-.023.018-.042.059-.083L454.073 512 166.371 224.297c-.041-.04-.052-.06-.059-.083a.118.118 0 0 1 0-.07c.007-.022.018-.042.059-.083l57.69-57.69c.041-.041.06-.052.084-.059a.118.118 0 0 1 .069 0c.023.007.042.018.083.059L512 454.073l287.703-287.702c.04-.041.06-.052.083-.059a.118.118 0 0 1 .07 0Z"></path> </svg> </i> </button>
            </div>
          </Typography>


          {loading ? (
            <div className="text-center py-5">
              <i
                className="spinner-border text-primary"
                style={{ width: "3rem", height: "3rem", color: "#e3e3e3", borderColor: "#e3e3e3", }}
              ></i>
              <p className="mt-3 mesgColor">Loading history...</p>
            </div>
          ) : (
            <TableContainer className="historyListView" component={Paper} sx={{
              maxHeight: 300, // 
              overflowY: "auto",
            }}>
              <Table stickyHeader size="small" aria-label="history table">
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <b>S.No</b>
                    </TableCell>
                    <TableCell>
                      <b>File Name</b>
                    </TableCell>
                    <TableCell>
                      <b>Date & Time</b>
                    </TableCell>
                    <TableCell align="center">
                      <b>Download</b>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {historyData.length > 0 ? (
                    historyData.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{row.filename}</TableCell>
                        <TableCell>{row.last_modified}</TableCell>
                        <TableCell align="center">
                          <IconButton
                            color="success"
                            onClick={() => handleDownload(row.url, row.filename)}
                          >
                            <DownloadIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={4} align="center">
                        No records found
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Box>
      </Modal>

      {/* <Modal
        open={historyOpen}
        onClose={historyHandleClose}
        style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <Box sx={{ bgcolor: "background.paper", p: 4, borderRadius: 1, boxShadow: 24, width: 400 }}>
          <Typography variant="h6" component="h2" gutterBottom>
            <div className="my-3 position-relative">
              <button className="btn btn-close-mapping" onClick={historyHandleClose}>
                <i>
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    strokeWidth="0"
                    viewBox="0 0 1024 1024"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M799.855 166.312..."></path>
                  </svg>
                </i>
              </button>
              <div className="d-flex align-items-center justify-content-center mb-1">
                <i className="checkIcon">
                  <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="100%" width="100%">
                    <path d="M256 48a208..."></path>
                  </svg>
                </i>
              </div>
              <div className="d-flex align-items-center justify-content-center">
                Report viewed successfully!
              </div>
            </div>
          </Typography>
        </Box>
      </Modal> */}

      <Modal
        open={open}
        onClose={handleClose}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            bgcolor: "#303030",
            p: 4,
            borderRadius: 1,
            boxShadow: 24,
            width: 400,
            position: "relative",
          }}
        >
          <Typography variant="h6" component="h2" gutterBottom>
            <div className="my-3 position-relative">
              <button className="btn btn-close-mapping" onClick={handleClose}>
                <i>
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    strokeWidth="0"
                    viewBox="0 0 1024 1024"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M799.855 166.312c.023.007.043.018.084.059l57.69 57.69c.041.041.052.06.059.084a.118.118 0 0 1 0 .069c-.007.023-.018.042-.059.083L569.926 512l287.703 287.703c.041.04.052.06.059.083a.118.118 0 0 1 0 .07c-.007.022-.018.042-.059.083l-57.69 57.69c-.041.041-.06.052-.084.059a.118.118 0 0 1-.069 0c-.023-.007-.042-.018-.083-.059L512 569.926 224.297 857.629c-.04.041-.06.052-.083.059a.118.118 0 0 1-.07 0c-.022-.007-.042-.018-.083-.059l-57.69-57.69c-.041-.041-.052-.06-.059-.084a.118.118 0 0 1 0-.069c.007-.023.018-.042.059-.083L454.073 512 166.371 224.297c-.041-.04-.052-.06-.059-.083a.118.118 0 0 1 0-.07c.007-.022.018-.042.059-.083l57.69-57.69c.041-.041.06-.052.084-.059a.118.118 0 0 1 .069 0c.023.007.042.018.083.059L512 454.073l287.703-287.702c.04-.041.06-.052.083-.059a.118.118 0 0 1 .07 0Z"></path>
                  </svg>
                </i>
              </button>

              <div className="d-flex align-items-center justify-content-center mb-2">
                <i className="checkIcon">
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    strokeWidth="0"
                    viewBox="0 0 512 512"
                    height="100%"
                    width="100%"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"></path>
                  </svg>
                </i>
              </div>

              <div className="d-flex align-items-center justify-content-center">
                <span className="mesgColor"> Process Run Successfully!</span>
              </div>
            </div>
          </Typography>
        </Box>
      </Modal>

      <Modal
        open={errorModalOpen}
        onClose={() => setErrorModalOpen(false)}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            bgcolor: "#303030",
            p: 4,
            borderRadius: 1,
            boxShadow: 24,
            width: 400,
            position: "relative",
          }}
        >
          <Typography variant="h6" component="h2" gutterBottom>
            <div className="my-3 position-relative">
              <button className="btn btn-close-mapping" onClick={() => setErrorModalOpen(false)}>
                <i>
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    strokeWidth="0"
                    viewBox="0 0 1024 1024"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M799.855 166.312c.023.007.043.018.084.059l57.69 57.69c.041.041.052.06.059.084a.118.118 0 0 1 0 .069c-.007.023-.018.042-.059.083L569.926 512l287.703 287.703c.041.04.052.06.059.083a.118.118 0 0 1 0 .07c-.007.022-.018.042-.059.083l-57.69 57.69c-.041.041-.06.052-.084.059a.118.118 0 0 1-.069 0c-.023-.007-.042-.018-.083-.059L512 569.926 224.297 857.629c-.04.041-.06.052-.083.059a.118.118 0 0 1-.07 0c-.022-.007-.042-.018-.083-.059l-57.69-57.69c-.041-.041-.052-.06-.059-.084a.118.118 0 0 1 0-.069c.007-.023.018-.042.059-.083L454.073 512 166.371 224.297c-.041-.04-.052-.06-.059-.083a.118.118 0 0 1 0-.07c.007-.022.018-.042.059-.083l57.69-57.69c.041-.041.06-.052.084-.059a.118.118 0 0 1 .069 0c.023.007.042.018.083.059L512 454.073l287.703-287.702c.04-.041.06-.052.083-.059a.118.118 0 0 1 .07 0Z"></path>
                  </svg>
                </i>
              </button>

              <div className="d-flex align-items-center justify-content-center mb-2">
                <i className="checkIcon">
                  <svg
                    stroke="#db2128"
                    fill="#db2128"
                    stroke-width="0"
                    viewBox="0 0 16 16"
                    height="100%"
                    width="100%"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8.6 1c1.6.1 3.1.9 4.2 2 1.3 1.4 2 3.1 2 5.1 0 1.6-.6 3.1-1.6 4.4-1 1.2-2.4 2.1-4 2.4-1.6.3-3.2.1-4.6-.7-1.4-.8-2.5-2-3.1-3.5C.9 9.2.8 7.5 1.3 6c.5-1.6 1.4-2.9 2.8-3.8C5.4 1.3 7 .9 8.6 1zm.5 12.9c1.3-.3 2.5-1 3.4-2.1.8-1.1 1.3-2.4 1.2-3.8 0-1.6-.6-3.2-1.7-4.3-1-1-2.2-1.6-3.6-1.7-1.3-.1-2.7.2-3.8 1-1.1.8-1.9 1.9-2.3 3.3-.4 1.3-.4 2.7.2 4 .6 1.3 1.5 2.3 2.7 3 1.2.7 2.6.9 3.9.6zM7.9 7.5L10.3 5l.7.7-2.4 2.5 2.4 2.5-.7.7-2.4-2.5-2.4 2.5-.7-.7 2.4-2.5-2.4-2.5.7-.7 2.4 2.5z"
                    ></path>
                  </svg>
                </i>
              </div>

              <div className="d-flex align-items-center justify-content-center">
                <span className="mesgColor"> {"Something Went Wrong!"}</span>
              </div>
            </div>
          </Typography>
        </Box>
      </Modal>
    </div>
  );
}

export default Field_Mapping;
